import { getConnectedServiceStatus } from "../../connectedServicesApi";
import { SERVICE_GMAIL } from "../../registry";
import { createGmailProvider } from "./gmailProvider";

/**
 * Selects the active email provider for the current user.
 * Phase 1: Gmail only. Future: prefer connected provider, then default.
 * @returns {Promise<import("../emailProviderTypes").EmailProvider | null>}
 */
export async function resolveActiveEmailProvider() {
  // Phase 1 registry — add Outlook / others here later.
  const candidates = [createGmailProvider()];

  for (const provider of candidates) {
    try {
      if (await provider.isConnected()) {
        return provider;
      }
    } catch {
      // Try next candidate.
    }
  }

  // No provider connected: still return the default so Ashley gets a clear connect prompt.
  const gmailStatus = await getConnectedServiceStatus(SERVICE_GMAIL).catch(() => null);
  if (gmailStatus || candidates[0]) {
    return candidates[0];
  }

  return null;
}
